import { createApp } from 'vue'

import App from './App.vue'
//import { loadFonts } from './plugins/webfontloader'

// Design System Styles
import './scss/main.scss'

// UI Components
import UIComponents from './components/ui'

// Toast Plugin
import ToastPlugin from './plugins/toast'

import moment from 'moment'

import store from "./store"
import { odistCanRead, odistCanWrite, odistOption, permWriteDirective } from '@/utils/odistPerm'
import axios from 'axios'
import router from './router'

import mitt from 'mitt';

const emitter = mitt()
//loadFonts()

const app = createApp(App)



import VueObserveVisibility from 'vue3-observe-visibility'
app.use(VueObserveVisibility)

app.config.globalProperties.$eventBus = emitter
app.config.globalProperties.$eventBus.$emit = emitter.emit
app.config.globalProperties.$eventBus.$on = emitter.on
app.config.globalProperties.$eventBus.$off = emitter.off

app.use(store)
app.use(router)
app.use(UIComponents)
app.use(ToastPlugin)

// BETA 환경에서는 cross-origin API 요청 시 쿠키 포함을 위해 withCredentials 전역 설정
if (process.env.VUE_APP_ADMIN_URL === 'https://admin2.myshop-dev.in') {
    axios.defaults.withCredentials = true
}

// fetch() 요청에도 token 및 ERP API uid 헤더 자동 추가 (axios interceptor가 적용되지 않는 fetch 호출 대응)
const originalFetch = window.fetch;
window.fetch = function(url, options = {}) {
    if (typeof url === 'string') {
        // 내부 API 요청에 login_token 자동 추가
        const token = store.state.login_token;
        if (token) {
            const isRelativePath = url.startsWith('/');
            const isInternalApi = url.includes('shockping.com') || url.includes('qro.do') ||
                url.includes('myshop-dev.in') || url.includes('mshp.in') ||
                url.includes('snadx.com') || url.includes('myshop-order.com') || url.includes('mocoplex.com');
            if ((isRelativePath || isInternalApi) && !url.includes('token=')) {
                const separator = url.includes('?') ? '&' : '?';
                url = url + separator + 'token=' + encodeURIComponent(token);
            }
        }
        // ERP API uid 헤더
        if (url.startsWith('/erp-api')) {
            const uid = store.state.login_data?.uid;
            if (uid) {
                options.headers = options.headers || {};
                if (!options.headers['uid']) {
                    options.headers['uid'] = uid;
                }
            }
        }
    }
    return originalFetch.call(this, url, options);
};

// Request 인터셉터: 모든 내부 API 요청에 login_token 자동 추가
axios.interceptors.request.use((config) => {
    const token = store.state.login_token;
    if (token && config.url) {
        // 상대 경로 또는 내부 API 경로에만 token 추가
        const isRelativePath = config.url.startsWith('/');
        const isInternalApi = config.url.includes('shockping.com') ||
                              config.url.includes('qro.do') ||
                              config.url.includes('myshop-dev.in') ||
                              config.url.includes('mshp.in') ||
                              config.url.includes('snadx.com') ||
                              config.url.includes('myshop-order.com') ||
                              config.url.includes('mocoplex.com');

        if (isRelativePath || isInternalApi) {
            // URL에 이미 token이 있는지 확인
            const hasToken = config.url.includes('token=');
            if (!hasToken) {
                const separator = config.url.includes('?') ? '&' : '?';
                config.url = config.url + separator + 'token=' + encodeURIComponent(token);
            }
        }
    }
    // ERP API 요청에 uid 헤더 자동 추가
    const uid = store.state.login_data?.uid;
    if (uid && config.url && config.url.startsWith('/erp-api')) {
        if (!config.headers) config.headers = {};
        if (!config.headers['uid']) {
            config.headers['uid'] = uid;
        }
    }
    return config;
}, function (error) {
    return Promise.reject(error);
});

axios.interceptors.response.use((response) => {
    return response;
}, function (error) {
    // Do something with response error
    /*
    if (error.response.status === 401) {
        console.log('unauthorized, logging out ...');
        auth.logout();
        router.replace('/auth/login');
    }
    */
    return Promise.reject(error.response);
});

app.config.globalProperties.$fs_url = 'https://img0-upload.adnext.co'

app.config.globalProperties.$ymd = function (date) {
    if(!!date) {
//        return moment('YYYY.MM.DD HH:mm:ss')
        var v = moment(date).format('YYYY.MM.DD HH:mm:ss').toString()
        return '<span style="">'+v+'</span>'
    }
    return v
    //{{ item.regdate | moment('YYYY.MM.DD HH:mm:ss')}}
}
app.config.globalProperties.$http = axios

// odist 서브계정 권한 (2026-08-24). 서브계정이 아니면 전부 true.
//   this.$odistCan('order')            → 쓰기 가능?
//   this.$odistCan('order', 'read')    → 조회 가능?
//   this.$odistOption('show_purchase_price')
//   <button v-perm-write="'order'">    → 쓰기 권한 없으면 숨김
app.config.globalProperties.$odistCan = function (key, level) {
    return level === 'read' ? odistCanRead(store, key) : odistCanWrite(store, key)
}
app.config.globalProperties.$odistOption = function (key) { return odistOption(store, key) }
app.directive('perm-write', permWriteDirective(store))

app.config.globalProperties.$xls = function (url,data) {

    let getFilenameFromDisposition = function(disposition) {
        if (!disposition) return null;
        // RFC 5987: filename*=UTF-8''<urlencoded>
        let m = /filename\*=UTF-8''([^;]+)/i.exec(disposition);
        if (m && m[1]) return decodeURIComponent(m[1]);

        // filename="<quoted>"
        m = /filename="([^"]+)"/i.exec(disposition);
        if (m && m[1]) return m[1];

        // filename=unquoted
        m = /filename=([^;]+)/i.exec(disposition);
        if (m && m[1]) return m[1].trim();

        return null;
    }

    axios.post(url, data,
        {
            responseType: 'blob',
            headers: { 'Content-Type': 'application/json' },
        }
    )
        .then(res => {
            const contentType = res.headers['content-type']
                || 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet';
            const filename = getFilenameFromDisposition(res.headers['content-disposition'])
                || 'export.xlsx';

            const blob = new Blob([res.data], { type: contentType });


            try {
                const link = document.createElement('a');
                const urlObj = URL.createObjectURL(blob);
                link.href = urlObj;
                link.download = filename;
                document.body.appendChild(link);
                link.click();
                link.remove();
                URL.revokeObjectURL(urlObj);
            } catch (err) {
                console.error('Download error:', err);
                alert('Failed to download file.');
            }

        }).catch(err=>{
    })
}

app.config.globalProperties.$have_to_login = function() {
    var d = this.$store.state.login_data
    console.log(d)
}

app.config.globalProperties.$order_status = function(item, exceptional_refund) {

    if(item=='WAITING_PAYMENT') {
        return '결제 대기중';
    } else if(item=='CONFIRM_PAYMENT') {
        return '결제 완료';
    } else if(item=='READY_FOR_DELIVERY') {
        return '조리중';
    } else if(item=='DONE') {
        return '완료';
    } else if(item=='CANCELED') {
        return '취소';
    }

    return '상태 변경됨'
}


app.config.globalProperties.$order_status_color = function(item, exceptional_refund) {

    if(item=='WAITING_PAYMENT') {
        return 'yellow';
    } else if(item=='CONFIRM_PAYMENT') {
        return 'blue';
    } else if(item=='READY_FOR_DELIVERY') {
        return 'green';
    } else if(item=='DONE') {
        return 'red';
    }

    return 'primary'
}


app.config.globalProperties.$pxy = '//cdnpxy0.mocoplex.com/crop/300x300/'

app.config.globalProperties.$cookie = {

    delete_cookie:function(name, path, domain) {
        var v = this.getCookie2(name)

        if( !!v ) {
            document.cookie = name + "=" +
                ((path) ? ";path="+path:"")+
                ((domain)?";domain="+domain:"") +
                ";expires=Thu, 01 Jan 1970 00:00:01 GMT";
        }
    },
    setCookie365:function(name, value) {
        this.setCookie2(name, value, 60*24*365)
    },
    setCookie3:function(name, value) {
        this.setCookie2(name, value, 60*24*7)
    },
    setCookie_dom:function(name, value, dom) {
        this.setCookie2(name, value, 60*24*30, dom)
    },
    setCookie2:function(name, value, mins, dom) {
        var expires = ''
        if (mins) {
            var date = new Date();
            date.setTime(date.getTime() + (mins * 60 * 1000));
            expires = "; expires=" + date.toGMTString()

            if(dom) {
                expires += "; domain=" + dom
            }
        } else {
            expires = "";
        }
        document.cookie = name + "=" + value + expires + "; path=/";
    },
    getCookie2:function(name) {
        var i, x, y, ARRcookies = document.cookie.split(";");
        for (i = 0; i < ARRcookies.length; i++) {
            x = ARRcookies[i].substr(0, ARRcookies[i].indexOf("="));
            y = ARRcookies[i].substr(ARRcookies[i].indexOf("=") + 1);
            x = x.replace(/^\s+|\s+$/g, "");
            if (x == name) {
                return unescape(y);
            }
        }
    },
}


// global
// 숫자 타입에서 쓸 수 있도록 format() 함수 추가
Number.prototype.price = function (w) {
    //if (this == 0) return 0;

    var reg = /(^[+-]?\d+)(\d{3})/;
    var n = (this + '');

    while (reg.test(n)) n = n.replace(reg, '$1' + ',' + '$2');

    if (w != null)
        return n + " <span class='won'>" + w + "</span>";
    else
        return n
};


// 숫자 칸 휠 막기(2026-10-23 케뷰 "발주계획에서 수량 칸을 클릭하면 담은 품목으로 넘어가고 수량 미입력이 뜬다")
// — 숫자 칸에 커서를 둔 채 마우스 휠로 목록을 내리면 크롬이 그 칸 값을 바꾼다(빈 칸 → 0). 발주계획은 그 줄이 수량 0으로 담겼고,
//   입고 확인 입고수량·단가 칸도 같은 일이 생길 수 있다. 휠이 오면 그 칸에서 커서를 빼서 값은 그대로, 화면은 그대로 스크롤되게 한다.
document.addEventListener('wheel', e => {
    const t = e.target
    if (t && t.tagName === 'INPUT' && t.type === 'number' && document.activeElement === t) t.blur()
}, { capture: true, passive: true })

app.mount('#app')
